/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    REVIEW_USER_SIGNATURE_COMP
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted signature section for ReviewUserForm to comply with file size limits.
 * Contains user broadcast email signature.
 *
 * File Size Check:
 * - Current: ~50 lines
 * - Limit: 200 lines
 * - Decision: New component creation (under limit)
 *
 * Related Screens / Modules:
 * - client/src/components/setup/ReviewUserForm.tsx
 */
import React from "react";
import { Card } from "react-bootstrap";
import type { User } from "../../../../interfaces/User";

interface ReviewUserSignatureProps {
  profile: Partial<User> | null;
}

export const ReviewUserSignature: React.FC<ReviewUserSignatureProps> = ({ profile }) => {
  return (
    <Card className="review-card broadcast-signature-card" style={{ width: "100%", maxWidth: "100%" }}>
      <Card.Body>
        <h6 className="review-broadcast-title mb-1">My Broadcast Signature</h6>
        <div className="review-broadcast-subtitle mb-3">
          (will be presented in your broadcast email only)
        </div>
        <div className="review-broadcast-content">
          <div
            dangerouslySetInnerHTML={{
              __html: profile?.broadcastSignatureHtml || "<p>Not set</p>",
            }}
          />
        </div>
      </Card.Body>
    </Card>
  );
};
